import React from 'react';
import { bonuses, type Bonus } from '../data/bonuses';
import { SeedPaths } from './Seed';
function BonusCover({
  bonus
}: {
  bonus: Bonus;
}) {
  if (bonus.cover) {
    return <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-square w-full border-b border-paper-dark object-cover object-center" data-id="element-21" data-mp="av35ut3p3515" />;
  }
  return <div aria-hidden="true" className="stage-smoke relative flex h-[230px] items-center justify-center sm:h-[265px]" data-id="element-22" data-mp="1t3o1ykuvwx5">
      <div className="relative aspect-[4/5] w-[46%] max-w-[190px] overflow-hidden rounded-md bg-paper shadow-cover" data-id="element-23" data-mp="5tnkezxluwi8">
        <span className={`absolute inset-x-0 top-0 h-[4%] ${bonus.accent}`} data-id="element-24" data-mp="3t0ogy264l9mo" />
        <div className="px-[9%] pt-[14%]" data-id="element-25" data-mp="3t2sp4wb24usr">
          <span className="block text-[10px] font-bold text-teal-deep" data-id="element-26" data-mp="1m9yu96s58kuw">Bonus {bonus.number}</span>
          <span className="mt-1.5 block font-display text-[14px] leading-tight text-navy" data-id="element-27" data-mp="1r9l7vhbvw348">{bonus.title}</span>
        </div>
        <svg viewBox="-60 -60 120 120" className="absolute -bottom-6 left-1/2 h-24 w-24 -translate-x-1/2" data-id="element-28" data-mp="3id52z1tcov8o">
          <SeedPaths data-id="element-29" data-mp="3detuaueskqs1" />
        </svg>
      </div>
    </div>;
}
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-teal-soft" data-id="element-30" data-mp="3r68bqwt1wjwz">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-31" data-mp="3n6g2sizqwbr3">
        <div className="text-center" data-id="element-32" data-mp="2zfam61lzdffq">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-33" data-mp="2zgdf0f2v5rya">Also included at no extra cost</p>
          <h2 id="bonuses-heading" className="mt-3 font-display text-3xl text-navy sm:text-5xl" data-id="element-34" data-mp="2uhso569i4kmi">
            Five instant-use <span className="wash-text" data-id="element-35" data-mp="38htnuie15m0e">bonus tools</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-navy-soft" data-id="element-36" data-mp="33g4bmzf2n2aq">
            The volumes give you the year. These five get you teaching it this
            week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-37" data-mp="irq42w70v6dw">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-3xl bg-white shadow-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-38" data-mp="3cjpshb57fgtw" data-mpi={i}>
              <BonusCover bonus={bonus} data-id="element-39" data-mp="3qiflofowkwcz" />
              <div className="px-5 pb-6 pt-4" data-id="element-40" data-mp="3qhe7w3gi5vrk">
                <div className="flex flex-wrap items-center gap-2" data-id="element-41" data-mp="2tsf4b1qv5i5p">
                  <span className="text-xs font-semibold text-navy-muted" data-id="element-42" data-mp="2tu9mw9enwy6m">Bonus {bonus.number}</span>
                  <span className="rounded-full bg-peach-soft px-2.5 py-1 text-[11px] font-bold text-peach-deep" data-id="element-43" data-mp="2xua4u40yzrif">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl leading-snug text-navy" data-id="element-44" data-mp="37l4or1qquf0p">{bonus.title}</h3>
                <p className="mt-2 text-sm text-navy-soft" data-id="element-45" data-mp="2a45yhoweddnq">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}